import { FC } from "react";

import { Box } from "@mui/material";

import { useLocaleContext } from "../../../../../../common/contexts/LocaleContext";
import { getChoiceLabel } from "../../../helpers/getLabel";

import { getChoiceAvailableCount } from "@/common/helpers/customAnswerChoices.helper";
import * as useTranslate from "@/common/hooks/useTranslate";
import { ChoiceOutput } from "@/common/types/trpc";
import { FormTypography } from "@/forms-design-system/FormTypography";

export interface QuestionFieldChoiceProps {
  choice: ChoiceOutput;
  answersOfParticipantsSelectedChoicesCount: Record<string, number> | undefined;
  hideAvailability?: boolean;
}

export const QuestionFieldChoice: FC<QuestionFieldChoiceProps> = ({
  choice,
  answersOfParticipantsSelectedChoicesCount,
  hideAvailability,
}) => {
  const { t } = useTranslate.useTranslate();
  const { locale } = useLocaleContext();
  const label = getChoiceLabel(choice.choiceFields || [], locale);
  const maximum = choice.maximum;
  const availableCount = getChoiceAvailableCount(choice, answersOfParticipantsSelectedChoicesCount);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        columnGap: 2,
      }}
    >
      {/* Label */}
      <FormTypography
        variant="body2"
        sx={{
          flexGrow: 1,
          whiteSpace: "normal",
        }}
        vibe="moderate"
        data-test="choice-label-typography"
      >
        {label}
      </FormTypography>

      {/* Availability */}
      {maximum !== null && maximum !== undefined && maximum >= 0 && !hideAvailability && (
        <FormTypography variant="caption" data-test="choice-label-available-typography" vibe="supershy">
          {availableCount > 0
            ? t("ticketing", "choice.availableCount", { count: availableCount })
            : t("ticketing", "choice.notAvailable")}
        </FormTypography>
      )}
    </Box>
  );
};
